import { CustomerAttribute } from '@mfec/customerAttributes/types';

export const customerAttributeDiffers = (cattr1: CustomerAttribute, cattr2: CustomerAttribute) => {
  const cattr1ExtraItems = cattr1.extra.items.map((item) => ({ id: item.id, granted: item.granted })).sort((a, b) => (a.id < b.id ? -1 : 1));
  const cattr2ExtraItems = cattr2.extra.items.map((item) => ({ id: item.id, granted: item.granted })).sort((a, b) => (a.id < b.id ? -1 : 1));
  return JSON.stringify(cattr1ExtraItems) !== JSON.stringify(cattr2ExtraItems);
};

export const customerAttributesDiffer = (cattrs1 : CustomerAttribute[] | undefined, cattrs2: CustomerAttribute[] | undefined) => {
  let hasChangedCustomerAttributes = false;
  if (Array.isArray(cattrs1) && Array.isArray(cattrs2)) {
    hasChangedCustomerAttributes = cattrs1.some((customerAttribute) => {
      const customerAttributesOrigin = cattrs2.find((cattr) => cattr.id === customerAttribute.id);
      if (!customerAttributesOrigin) return false;
      return customerAttributeDiffers(customerAttribute, customerAttributesOrigin);
    });
  }
  return hasChangedCustomerAttributes;
};
